import { render, staticRenderFns } from "./PluginIcon.vue?vue&type=template&id=5b5c9f74&scoped=true&"
import script from "./PluginIcon.vue?vue&type=script&lang=js&"
export * from "./PluginIcon.vue?vue&type=script&lang=js&"
import style0 from "./PluginIcon.vue?vue&type=style&index=0&id=5b5c9f74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5c9f74",
  null
  
)

export default component.exports